/**
 * Web 端扫码内容：外链形式，微信直扫需配置「扫普通链接二维码打开小程序」到 pages/scan/entry；
 * 小程序内扫可直接解析 t/id。
 */
export const SCAN_HOST = 'https://zf.buildbee.cn'
export const SCAN_PATH = '/mp/s'

export function buildScanUrl(type, id, extra = {}) {
  const t = String(type || '').toUpperCase()
  const uid = String(id || '').trim()
  if (!t || !uid) return ''
  let url =
    SCAN_HOST +
    SCAN_PATH +
    '?t=' +
    encodeURIComponent(t) +
    '&id=' +
    encodeURIComponent(uid)
  Object.keys(extra || {}).forEach((key) => {
    const val = extra[key]
    if (val === undefined || val === null || val === '') return
    url +=
      '&' + encodeURIComponent(key) + '=' + encodeURIComponent(String(val))
  })
  return url
}

export function buildDiscloseQcodeInfo(info, uid) {
  const orgUid = uid || (info && (info.orgUid || info.uid)) || ''
  return {
    qcodeUrl: buildScanUrl('BID', orgUid),
    qcodeName:
      (info && (info.projectCode || info.orgName || info.name)) || '标段信息披露',
    project: '微信扫码查看标段信息',
    leftText: '信息公开',
    rightText: '扫码查阅'
  }
}

export function buildTrainingScanQcodeInfo(item) {
  const uid = item && (item.uid || item.trainingUid)
  return {
    // 优先外链（A+B）；保留历史加密串作 qcodeLegacy 供对照
    qcodeUrl: buildScanUrl('JYPX', uid) || (item && item.qrcode) || '',
    qcodeLegacy: (item && item.qrcode) || '',
    qcodeName: (item && item.trainingName) || '教育培训',
    project: '扫码签到并进入培训/考试',
    leftText: '用诚信企业',
    rightText: '干品质工程'
  }
}

export function buildMixingScanQcodeInfo(orgUid, meta = {}) {
  return {
    qcodeUrl: buildScanUrl('SCZL', orgUid) || 'SCZL@|@' + orgUid,
    qcodeLegacy: 'SCZL@|@' + orgUid,
    qcodeName: meta.qcodeName || '拌合站生产码',
    leftText: meta.leftText || '拌合生产',
    rightText: meta.rightText || '扫码装料',
    project: meta.project || ''
  }
}

export function buildShipmentSignQcodeInfo(row) {
  const uid = row && row.uid
  return {
    qcodeUrl: buildScanUrl('YSD', uid),
    qcodeName: (row && row.shipmentNum) || '运输单签收',
    project: '现场扫码进入签收办理',
    leftText: '物料运输',
    rightText: '扫码签收'
  }
}
